import { IconProps, NocIconGenerator } from '../common';

export const Family = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        css={{
            '& path': {
                strokeWidth: '1.2 !important',
            },
        }}
        createIconProps={{
            displayName: 'Family',
            path: (
                <path
                    d="M7.99951 11.79C7.2895 10.26 5.4295 9.57999 3.84951 10.27C2.7295 10.76 1.99951 11.85 1.99951 13.04V15.65H3.34951L3.79951 20H6.48951L6.93951 15.65H7.83951M15.9994 11.79C16.7095 10.26 18.5695 9.57999 20.1495 10.27C21.2695 10.76 21.9994 11.85 21.9994 13.04V15.65H20.6494L20.1994 20H17.5095L17.0595 15.65H16.1595M9.99951 9C9.99951 10.1 10.8995 11 11.9995 11C13.0995 11 13.9995 10.1 13.9995 9C13.9995 7.89999 13.0995 7 11.9995 7C10.8995 7 9.99951 7.89999 9.99951 9ZM11.9995 12C10.6195 12 9.49951 13.07 9.49951 14.4V16.4H10.7495L11.1695 20H12.8395L13.2595 16.4H14.5095V14.4C14.5095 13.07 13.3895 12 12.0095 12H11.9995ZM2.49951 6C2.49951 7.38 3.61951 8.5 4.99951 8.5C6.37951 8.5 7.4995 7.38 7.4995 6C7.4995 4.62 6.37951 3.5 4.99951 3.5C3.61951 3.5 2.49951 4.62 2.49951 6ZM16.4995 6C16.4995 7.38 17.6194 8.5 18.9994 8.5C20.3794 8.5 21.4995 7.38 21.4995 6C21.4995 4.62 20.3794 3.5 18.9994 3.5C17.6194 3.5 16.4995 4.62 16.4995 6Z"
                    stroke="#212121"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ),
        }}
    />
);
